module.exports = __webpack_public_path__ + "media/images/icon-phone-outbound-88f4c02a28ed35732a02acb6fdec61a5.svg";